import React from "react";

import { PATIENT_WEB_PAGES } from "./PatientSide";
import { DOCTOR_WEB_PAGES } from "./DoctorSide";
import { ADMIN_WEB_PAGES } from "./AdminSide";

const NoPage = React.lazy(() => import("./NoPageFound"));
const Login = React.lazy(() => import("./Login"));
const LandingPage = React.lazy(() => import("./LandingPage"));
const ChatScreen = React.lazy(() =>
  import("../assets/genericComponents/ChatScreen")
);

const WEB_PAGES = {
  NOPAGE: NoPage,
  LOGIN: Login,
  LANDINGPAGE: LandingPage,
  CHATSCREEN: ChatScreen,
  // //////////////////////////////////Patient Web Pages////////////////////////////////////

  PATIENT_DASHBOARD: PATIENT_WEB_PAGES.DASHBOARD,
  PATIENT_MYVITALS: PATIENT_WEB_PAGES.MYVITALS,
  PATIENT_MANAGEPROFILE: PATIENT_WEB_PAGES.MANAGEPROFILE,
  PATIENT_PRESCRIPTION: PATIENT_WEB_PAGES.PATIENTPRESCRIPTION,
  PATIENT_PAYMENTDETAILS: PATIENT_WEB_PAGES.PAYMENTDETAILS,
  PATIENT_SEARCHDOCTOR: PATIENT_WEB_PAGES.SEARCHDOCTOR,
  PATIENT_COMMUNITYFORUM: PATIENT_WEB_PAGES.COMMUNITYFORUM,
  PATIENT_ASKQUERY: PATIENT_WEB_PAGES.ASKQUERY,
  PATIENT_APPOINTMENT: PATIENT_WEB_PAGES.PATIENTAPPOINTMENT,
  PATIENT_BOOKAPPOINTMENT: PATIENT_WEB_PAGES.BOOKAPPOINTMENT,

  // //////////////////////////////////Doctor Web Pages////////////////////////////////////

  DOCTOR_DASHBOARD: DOCTOR_WEB_PAGES.DASHBOARD,
  DOCTOR_MANAGEPROILE: DOCTOR_WEB_PAGES.MANAGEPROFILE,
  DOCTOR_INCOME: DOCTOR_WEB_PAGES.INCOME,
  DOCTOR_PRESCRIPTION: DOCTOR_WEB_PAGES.PRESCRIPTION,
  DOCTOR_APPOINTMENT_FEE: DOCTOR_WEB_PAGES.APPOINTMENTFEE,
  DOCTOR_COMMUNITYFORUM: DOCTOR_WEB_PAGES.COMMUNITYFORUM,
  DOCTOR_APPOINTMENTS: DOCTOR_WEB_PAGES.APPOINTMENTS,
  // DOCTOR_LIST_OF_APPOINTMENTS: DOCTOR_WEB_PAGES.LISTOFAPPOINTMENTS,
  // DOCTOR_MANAGE_APPOINTMENTS: DOCTOR_WEB_PAGES.MANAGEAPPOINTMENTS,
  // //////////////////////////////////Admin Web Pages////////////////////////////////////

  ADMIN_DASHBOARD: ADMIN_WEB_PAGES.DASHBOARD,
  ADMIN_DOCTORLIST: ADMIN_WEB_PAGES.ADMIN_DOCTORLIST,
  ADMIN_PATIENTLIST: ADMIN_WEB_PAGES.ADMIN_PATIENTLIST,
  ADMIN_CALLLOGS: ADMIN_WEB_PAGES.ADMIN_CALLLOGS,
  ADMIN_MANAGEQUERY: ADMIN_WEB_PAGES.ADMIN_MANAGEQUERY,
  ADMIN_PAYMENTDETAILS: ADMIN_WEB_PAGES.ADMIN_PAYMENTDETAILS,
  ADMIN_FAQS: ADMIN_WEB_PAGES.ADMIN_FAQS,
  ADMIN_MANAGECONTACTUS: ADMIN_WEB_PAGES.ADMIN_MANAGECONTACTUS,
};

export { WEB_PAGES };
